/**
 * The desktop app's bridge to its main process, as the preload script
 * exposes it on `window.electronAPI`.
 */

import type { EvmWalletApi, WalletSeedApi } from "../types/evm";

/** A request to an embedded server's API, carried out by the main process. */
export interface EmbeddedApiRequest {
  method: "GET" | "POST" | "DELETE";
  /** Path below /api, starting with "/" */
  path: string;
  password?: string;
  /** JSON text, or raw bytes */
  body?: string | ArrayBuffer;
  timeoutMs: number;
}

export interface EmbeddedApiResponse {
  status: number;
  body: string;
}

/** The part of the preload API that shared code calls. */
interface ElectronAPI {
  cacheWalletCredentials: (credentials: {
    walletName: string;
    password: string;
    network: string;
  }) => Promise<void>;
  clearWalletCredentials: () => Promise<void>;

  satchelApiRequest: (request: EmbeddedApiRequest) => Promise<EmbeddedApiResponse>;
  rgbLibApiRequest: (request: EmbeddedApiRequest) => Promise<EmbeddedApiResponse>;

  evm: EvmWalletApi;
  walletSeed: WalletSeedApi;
}

/** The preload API, or undefined outside the desktop app. */
export const getElectronAPI = (): ElectronAPI | undefined => {
  if (typeof window !== "undefined" && "electronAPI" in window) {
    return (window as Window & { electronAPI?: ElectronAPI }).electronAPI;
  }
  return undefined;
};
